import { jsx as v, jsxs as O } from "react/jsx-runtime";
import { createContext as j, forwardRef as T, useState as q, useRef as E, useImperativeHandle as I, useContext as S, useEffect as $ } from "react";
import { useTracking as z } from "../utils.js";
import l from "./toggles.module.css.js";
import A from "clsx/lite";
const y = j(
  {}
), H = T(function({
  children: n,
  className: s,
  defaultValue: e = "",
  fill: r = !1,
  onChange: o,
  tracking: t = !0,
  value: c,
  variant: i = "blue-grouped",
  ...u
}, g) {
  const [f, d] = q(e), p = E(null), R = c ?? f, [h, w] = i.split("-"), V = A(
    s,
    l.toggles,
    l[h],
    l[w],
    !!r && l.fill
  ), x = z(t), D = (m, L, b) => {
    d(m), b && x({
      eventCategory: "toggles",
      eventAction: "change",
      eventLabel: `${L || m}`,
      ...b === !0 ? {} : b
    }), o == null || o(m);
  };
  return I(g, () => p.current), k(p, w), /* @__PURE__ */ v(y.Provider, { value: { setValue: D, track: x, value: R }, children: /* @__PURE__ */ v(
    "div",
    {
      className: V,
      onKeyDown: F,
      ref: p,
      role: "radiogroup",
      ...u,
      children: n
    }
  ) });
}), N = T(function({ children: n, className: s, icon: e, tracking: r = !0, onClick: o, ...t }, c) {
  const { setValue: i, value: u } = S(y), g = t.value === u;
  return !n && !t["aria-label"] && console.warn("Toggle must have children or aria-label to be accessible."), /* @__PURE__ */ O(
    "button",
    {
      "aria-checked": g,
      className: A(l.toggle, s),
      onClick: (f) => {
        const d = f.currentTarget.textContent || t["aria-label"];
        i(t.value, d, r), o == null || o(f);
      },
      ref: c,
      role: "radio",
      tabIndex: u === void 0 || g ? 0 : -1,
      type: "button",
      ...t,
      children: [
        e,
        /* @__PURE__ */ v("span", { children: n })
      ]
    }
  );
}), B = Object.assign(H, { Toggle: N }), k = (a, n) => $(() => {
  if (n !== "grouped" || !window.ResizeObserver || !a.current) return;
  const s = a.current, e = s.querySelectorAll(`.${l.toggle}`), r = new ResizeObserver(
    () => window.requestAnimationFrame(() => {
      const o = e[0].offsetTop < e[e.length - 1].offsetTop;
      s.classList.toggle(l.grouped, !o), s.classList.toggle(l.separated, o);
    })
  );
  return r.observe(s), () => r.disconnect();
}, [a, n]), F = (a) => {
  var c;
  const { currentTarget: n, target: s, key: e } = a, r = n.querySelectorAll(`.${l.toggle}`), o = [...r].findIndex((i) => i.contains(s));
  let t = -1;
  (e === " " || e === "Enter") && ((c = r[t = o]) == null || c.click()), (e === "ArrowLeft" || e === "ArrowUp") && (t = o - 1), (e === "ArrowRight" || e === "ArrowDown") && (t = o + 1), e === "Home" && (t = 0), e === "End" && (t = r.length - 1), r[t] && (a.preventDefault(), r[t].focus());
};
export {
  B as Toggles
};
//# sourceMappingURL=toggles.js.map
